const state = {
  produkte: {
    Beilage: {
      'Rota 42.5g': {
        type: 'paged',
        bild: 'produkt-beilage.png',
        kategoriename: 'Beilage',
        verarbeitung: 'beilagen',
        druckkosten: 'seiten-gewicht-gestaffelt',
        minmenge: 2500,
        items: [
          {
            seiten: 12,
            gewicht: 17,
            preise: [
              {
                menge: 2500,
                grundpreis: 1458.92,
                weiteretausend: 43.05,
              },
              {
                menge: 5000,
                grundpreis: 1324.38,
                weiteretausend: 43.05,
              },
              {
                menge: 10000,
                grundpreis: 1718.4,
                weiteretausend: 43.05,
              },
              {
                menge: 20000,
                grundpreis: 2148.95,
                weiteretausend: 43.05,
              },
              {
                menge: 30000,
                grundpreis: 2579.49,
                weiteretausend: 43.05,
              },
              {
                menge: 40000,
                grundpreis: 3010.04,
                weiteretausend: 43.05,
              },
              {
                menge: 50000,
                grundpreis: 3440.59,
                weiteretausend: 43.05,
              },
              {
                menge: 100000,
                grundpreis: 5593.33,
                weiteretausend: 43.05,
              },
              {
                menge: 150000,
                grundpreis: 7746.07,
                weiteretausend: 43.05,
              },
              {
                menge: 200000,
                grundpreis: 9898.81,
                weiteretausend: 43.05,
              },
              {
                menge: 250000,
                grundpreis: 12051.55,
                weiteretausend: 43.05,
              },
              {
                menge: 300000,
                grundpreis: 14204.29,
                weiteretausend: 43.05,
              },
            ],
          },
          {
            seiten: 16,
            gewicht: 23,
            preise: [
              {
                menge: 2500,
                grundpreis: 1495.5,
                weiteretausend: 48.88,
              },
              {
                menge: 5000,
                grundpreis: 1552.67,
                weiteretausend: 48.88,
              },
              {
                menge: 10000,
                grundpreis: 1797.05,
                weiteretausend: 48.88,
              },
              {
                menge: 20000,
                grundpreis: 2285.82,
                weiteretausend: 48.88,
              },
              {
                menge: 30000,
                grundpreis: 2774.59,
                weiteretausend: 48.88,
              },
              {
                menge: 40000,
                grundpreis: 3263.35,
                weiteretausend: 48.88,
              },
              {
                menge: 50000,
                grundpreis: 3752.12,
                weiteretausend: 48.88,
              },
              {
                menge: 100000,
                grundpreis: 6195.95,
                weiteretausend: 48.88,
              },
              {
                menge: 150000,
                grundpreis: 8639.77,
                weiteretausend: 48.88,
              },
              {
                menge: 200000,
                grundpreis: 11083.6,
                weiteretausend: 48.88,
              },
              {
                menge: 250000,
                grundpreis: 13527.43,
                weiteretausend: 48.88,
              },
              {
                menge: 300000,
                grundpreis: 15971.26,
                weiteretausend: 48.88,
              },
            ],
          },
          {
            seiten: 20,
            gewicht: 29,
            preise: [
              {
                menge: 2500,
                grundpreis: 1770.6,
                weiteretausend: 54.67,
              },
              {
                menge: 5000,
                grundpreis: 1830.3,
                weiteretausend: 54.67,
              },
              {
                menge: 10000,
                grundpreis: 2103.66,
                weiteretausend: 54.67,
              },
              {
                menge: 20000,
                grundpreis: 2650.38,
                weiteretausend: 54.67,
              },
              {
                menge: 30000,
                grundpreis: 3197.09,
                weiteretausend: 54.67,
              },
              {
                menge: 40000,
                grundpreis: 3743.81,
                weiteretausend: 54.67,
              },
              {
                menge: 50000,
                grundpreis: 4290.53,
                weiteretausend: 54.67,
              },
              {
                menge: 100000,
                grundpreis: 7024.13,
                weiteretausend: 54.67,
              },
              {
                menge: 150000,
                grundpreis: 9757.72,
                weiteretausend: 54.67,
              },
              {
                menge: 200000,
                grundpreis: 12491.32,
                weiteretausend: 54.67,
              },
              {
                menge: 250000,
                grundpreis: 15224.91,
                weiteretausend: 54.67,
              },
              {
                menge: 300000,
                grundpreis: 17958.51,
                weiteretausend: 54.67,
              },
            ],
          },
          {
            seiten: 24,
            gewicht: 34,
            preise: [
              {
                menge: 2500,
                grundpreis: 1807.05,
                weiteretausend: 60.45,
              },
              {
                menge: 10000,
                grundpreis: 1879.62,
                weiteretausend: 60.45,
              },
              {
                menge: 20000,
                grundpreis: 2786.43,
                weiteretausend: 60.45,
              },
              {
                menge: 30000,
                grundpreis: 3390.97,
                weiteretausend: 60.45,
              },
              {
                menge: 40000,
                grundpreis: 3995.51,
                weiteretausend: 60.45,
              },
              {
                menge: 50000,
                grundpreis: 4600.05,
                weiteretausend: 60.45,
              },
              {
                menge: 100000,
                grundpreis: 7622.75,
                weiteretausend: 60.45,
              },
              {
                menge: 150000,
                grundpreis: 10645.46,
                weiteretausend: 60.45,
              },
              {
                menge: 200000,
                grundpreis: 13668.16,
                weiteretausend: 60.45,
              },
              {
                menge: 250000,
                grundpreis: 16690.86,
                weiteretausend: 60.45,
              },
              {
                menge: 300000,
                grundpreis: 19713.56,
                weiteretausend: 60.45,
              },
            ],
          },
          {
            seiten: 28,
            gewicht: 40,
            preise: [
              {
                menge: 2500,
                grundpreis: 2293.31,
                weiteretausend: 66.29,
              },
              {
                menge: 5000,
                grundpreis: 2359.33,
                weiteretausend: 66.29,
              },
              {
                menge: 10000,
                grundpreis: 2690.77,
                weiteretausend: 66.29,
              },
              {
                menge: 20000,
                grundpreis: 3353.66,
                weiteretausend: 66.29,
              },
              {
                menge: 30000,
                grundpreis: 4016.55,
                weiteretausend: 66.29,
              },
              {
                menge: 40000,
                grundpreis: 4679.44,
                weiteretausend: 66.29,
              },
              {
                menge: 50000,
                grundpreis: 5342.33,
                weiteretausend: 66.29,
              },
              {
                menge: 100000,
                grundpreis: 8656.78,
                weiteretausend: 66.29,
              },
              {
                menge: 150000,
                grundpreis: 15285.68,
                weiteretausend: 66.29,
              },
              {
                menge: 200000,
                grundpreis: 15285.68,
                weiteretausend: 66.29,
              },
              {
                menge: 250000,
                grundpreis: 18600.13,
                weiteretausend: 66.29,
              },
              {
                menge: 300000,
                grundpreis: 21914.58,
                weiteretausend: 66.29,
              },
            ],
          },
          {
            seiten: 32,
            gewicht: 46,
            preise: [
              {
                menge: 2500,
                grundpreis: 1880.26,
                weiteretausend: 72.11,
              },
              {
                menge: 5000,
                grundpreis: 1978.78,
                weiteretausend: 72.11,
              },
              {
                menge: 10000,
                grundpreis: 2339.34,
                weiteretausend: 72.11,
              },
              {
                menge: 20000,
                grundpreis: 3781.55,
                weiteretausend: 72.11,
              },
              {
                menge: 30000,
                grundpreis: 3781.55,
                weiteretausend: 72.11,
              },
              {
                menge: 40000,
                grundpreis: 4502.66,
                weiteretausend: 72.11,
              },
              {
                menge: 50000,
                grundpreis: 5223.77,
                weiteretausend: 72.11,
              },
              {
                menge: 100000,
                grundpreis: 8829.3,
                weiteretausend: 72.11,
              },
              {
                menge: 150000,
                grundpreis: 12434.84,
                weiteretausend: 72.11,
              },
              {
                menge: 200000,
                grundpreis: 16040.37,
                weiteretausend: 72.11,
              },
              {
                menge: 250000,
                grundpreis: 19645.91,
                weiteretausend: 72.11,
              },
              {
                menge: 300000,
                grundpreis: 23251.44,
                weiteretausend: 72.11,
              },
            ],
          },
          {
            seiten: 36,
            gewicht: 52,
            preise: [
              {
                menge: 2500,
                grundpreis: 2715.68,
                weiteretausend: 85.22,
              },
              {
                menge: 5000,
                grundpreis: 2810.64,
                weiteretausend: 85.22,
              },
              {
                menge: 10000,
                grundpreis: 3236.72,
                weiteretausend: 85.22,
              },
              {
                menge: 20000,
                grundpreis: 4088.87,
                weiteretausend: 85.22,
              },
              {
                menge: 30000,
                grundpreis: 4941.03,
                weiteretausend: 85.22,
              },
              {
                menge: 40000,
                grundpreis: 5793.18,
                weiteretausend: 85.22,
              },
              {
                menge: 50000,
                grundpreis: 6645.34,
                weiteretausend: 85.22,
              },
              {
                menge: 100000,
                grundpreis: 10906.11,
                weiteretausend: 85.22,
              },
              {
                menge: 150000,
                grundpreis: 15166.88,
                weiteretausend: 85.22,
              },
              {
                menge: 200000,
                grundpreis: 19427.65,
                weiteretausend: 85.22,
              },
              {
                menge: 250000,
                grundpreis: 23688.42,
                weiteretausend: 85.22,
              },
              {
                menge: 300000,
                grundpreis: 27949.19,
                weiteretausend: 85.22,
              },
            ],
          },
          {
            seiten: 40,
            gewicht: 57,
            preise: [
              {
                menge: 2500,
                grundpreis: 2144.7,
                weiteretausend: 90.94,
              },
              {
                menge: 5000,
                grundpreis: 2278.81,
                weiteretausend: 90.94,
              },
              {
                menge: 10000,
                grundpreis: 2733.53,
                weiteretausend: 90.94,
              },
              {
                menge: 20000,
                grundpreis: 3642.98,
                weiteretausend: 90.94,
              },
              {
                menge: 30000,
                grundpreis: 4552.43,
                weiteretausend: 90.94,
              },
              {
                menge: 40000,
                grundpreis: 5461.88,
                weiteretausend: 90.94,
              },
              {
                menge: 50000,
                grundpreis: 6371.32,
                weiteretausend: 90.94,
              },
              {
                menge: 100000,
                grundpreis: 10918.56,
                weiteretausend: 90.94,
              },
              {
                menge: 150000,
                grundpreis: 15465.8,
                weiteretausend: 90.94,
              },
              {
                menge: 200000,
                grundpreis: 20013.04,
                weiteretausend: 90.94,
              },
              {
                menge: 250000,
                grundpreis: 24560.28,
                weiteretausend: 90.94,
              },
              {
                menge: 300000,
                grundpreis: 29107.51,
                weiteretausend: 90.94,
              },
            ],
          },
          {
            seiten: 44,
            gewicht: 63,
            preise: [
              {
                menge: 2500,
                grundpreis: 3129.42,
                weiteretausend: 96.78,
              },
              {
                menge: 5000,
                grundpreis: 3235.31,
                weiteretausend: 96.78,
              },
              {
                menge: 10000,
                grundpreis: 3719.21,
                weiteretausend: 96.78,
              },
              {
                menge: 20000,
                grundpreis: 4687.0,
                weiteretausend: 96.78,
              },
              {
                menge: 30000,
                grundpreis: 5654.8,
                weiteretausend: 96.78,
              },
              {
                menge: 40000,
                grundpreis: 6622.6,
                weiteretausend: 96.78,
              },
              {
                menge: 50000,
                grundpreis: 7590.39,
                weiteretausend: 96.78,
              },
              {
                menge: 100000,
                grundpreis: 12429.38,
                weiteretausend: 96.78,
              },
              {
                menge: 150000,
                grundpreis: 17268.36,
                weiteretausend: 96.78,
              },
              {
                menge: 200000,
                grundpreis: 22107.35,
                weiteretausend: 96.78,
              },
              {
                menge: 250000,
                grundpreis: 26946.33,
                weiteretausend: 96.78,
              },
              {
                menge: 300000,
                grundpreis: 31785.32,
                weiteretausend: 96.78,
              },
            ],
          },
          {
            seiten: 48,
            gewicht: 69,
            preise: [
              {
                menge: 2500,
                grundpreis: 2260.47,
                weiteretausend: 102.65,
              },
              {
                menge: 5000,
                grundpreis: 2418.83,
                weiteretausend: 102.65,
              },
              {
                menge: 10000,
                grundpreis: 2932.1,
                weiteretausend: 102.65,
              },
              {
                menge: 20000,
                grundpreis: 3958.64,
                weiteretausend: 102.65,
              },
              {
                menge: 30000,
                grundpreis: 4985.18,
                weiteretausend: 102.65,
              },
              {
                menge: 40000,
                grundpreis: 6011.73,
                weiteretausend: 102.65,
              },
              {
                menge: 50000,
                grundpreis: 7038.27,
                weiteretausend: 102.65,
              },
              {
                menge: 100000,
                grundpreis: 12170.98,
                weiteretausend: 102.65,
              },
              {
                menge: 150000,
                grundpreis: 17303.69,
                weiteretausend: 102.65,
              },
              {
                menge: 200000,
                grundpreis: 22436.4,
                weiteretausend: 102.65,
              },
              {
                menge: 250000,
                grundpreis: 27569.11,
                weiteretausend: 102.65,
              },
              {
                menge: 300000,
                grundpreis: 32701.83,
                weiteretausend: 102.65,
              },
            ],
          },
          {
            seiten: 56,
            gewicht: 80,
            preise: [
              {
                menge: 2500,
                grundpreis: 2466.71,
                weiteretausend: 132.63,
              },
              {
                menge: 5000,
                grundpreis: 2691.04,
                weiteretausend: 132.63,
              },
              {
                menge: 10000,
                grundpreis: 3354.19,
                weiteretausend: 132.63,
              },
              {
                menge: 20000,
                grundpreis: 4680.5,
                weiteretausend: 132.63,
              },
              {
                menge: 30000,
                grundpreis: 6006.8,
                weiteretausend: 132.63,
              },
              {
                menge: 40000,
                grundpreis: 7333.11,
                weiteretausend: 132.63,
              },
              {
                menge: 50000,
                grundpreis: 8659.42,
                weiteretausend: 132.63,
              },
              {
                menge: 100000,
                grundpreis: 15290.96,
                weiteretausend: 132.63,
              },
              {
                menge: 200000,
                grundpreis: 28554.03,
                weiteretausend: 132.63,
              },
              {
                menge: 250000,
                grundpreis: 35185.57,
                weiteretausend: 132.63,
              },
              {
                menge: 300000,
                grundpreis: 41817.11,
                weiteretausend: 132.63,
              },
            ],
          },
          {
            seiten: 64,
            gewicht: 92,
            preise: [
              {
                menge: 2500,
                grundpreis: 2646.43,
                weiteretausend: 144.34,
              },
              {
                menge: 5000,
                grundpreis: 2892.22,
                weiteretausend: 144.34,
              },
              {
                menge: 10000,
                grundpreis: 3613.92,
                weiteretausend: 144.34,
              },
              {
                menge: 20000,
                grundpreis: 5057.32,
                weiteretausend: 144.34,
              },
              {
                menge: 30000,
                grundpreis: 6500.72,
                weiteretausend: 144.34,
              },
              {
                menge: 40000,
                grundpreis: 7944.13,
                weiteretausend: 144.34,
              },
              {
                menge: 50000,
                grundpreis: 9387.53,
                weiteretausend: 144.34,
              },
              {
                menge: 100000,
                grundpreis: 16604.54,
                weiteretausend: 144.34,
              },
              {
                menge: 150000,
                grundpreis: 23821.55,
                weiteretausend: 144.34,
              },
              {
                menge: 200000,
                grundpreis: 31038.56,
                weiteretausend: 144.34,
              },
              {
                menge: 250000,
                grundpreis: 38255.57,
                weiteretausend: 144.34,
              },
              {
                menge: 30000,
                grundpreis: 45472.59,
                weiteretausend: 144.34,
              },
            ],
          },
        ],
      },
      'Rota 55g': {
        type: 'paged',
        bild: 'produkt-beilage.png',
        kategoriename: 'Beilage',
        verarbeitung: 'beilagen',
        druckkosten: 'seiten-gewicht-gestaffelt',
        minmenge: 2500,
        items: [
          {
            seiten: 8,
            gewicht: 15,
            preise: [
              {
                menge: 2500,
                grundpreis: 1429.49,
                weiteretausend: 39.97,
              },
              {
                menge: 5000,
                grundpreis: 1467.25,
                weiteretausend: 39.97,
              },
              {
                menge: 10000,
                grundpreis: 1667.08,
                weiteretausend: 39.97,
              },
              {
                menge: 20000,
                grundpreis: 2066.73,
                weiteretausend: 39.97,
              },
              {
                menge: 30000,
                grundpreis: 2466.39,
                weiteretausend: 39.97,
              },
              {
                menge: 40000,
                grundpreis: 2866.04,
                weiteretausend: 39.97,
              },
              {
                menge: 50000,
                grundpreis: 3265.69,
                weiteretausend: 39.97,
              },
              {
                menge: 100000,
                grundpreis: 5263.96,
                weiteretausend: 39.97,
              },
              {
                menge: 150000,
                grundpreis: 7262.24,
                weiteretausend: 39.97,
              },
              {
                menge: 200000,
                grundpreis: 9260.51,
                weiteretausend: 39.97,
              },
              {
                menge: 250000,
                grundpreis: 11258.78,
                weiteretausend: 39.97,
              },
              {
                menge: 300000,
                grundpreis: 13257.05,
                weiteretausend: 39.97,
              },
            ],
          },
          {
            seiten: 12,
            gewicht: 22,
            preise: [
              {
                menge: 2500,
                grundpreis: 1469.63,
                weiteretausend: 47.15,
              },
              {
                menge: 5000,
                grundpreis: 1523.62,
                weiteretausend: 47.15,
              },
              {
                menge: 10000,
                grundpreis: 1759.38,
                weiteretausend: 47.15,
              },
              {
                menge: 20000,
                grundpreis: 2230.92,
                weiteretausend: 47.15,
              },
              {
                menge: 30000,
                grundpreis: 2702.45,
                weiteretausend: 47.15,
              },
              {
                menge: 40000,
                grundpreis: 3173.98,
                weiteretausend: 47.15,
              },
              {
                menge: 50000,
                grundpreis: 3645.52,
                weiteretausend: 47.15,
              },
              {
                menge: 100000,
                grundpreis: 6003.18,
                weiteretausend: 47.15,
              },
              {
                menge: 150000,
                grundpreis: 8360.85,
                weiteretausend: 47.15,
              },
              {
                menge: 200000,
                grundpreis: 10718.51,
                weiteretausend: 47.15,
              },
              {
                menge: 250000,
                grundpreis: 13076.18,
                weiteretausend: 47.15,
              },
              {
                menge: 300000,
                grundpreis: 15433.84,
                weiteretausend: 47.15,
              },
            ],
          },
          {
            seiten: 16,
            gewicht: 30,
            preise: [
              {
                menge: 2500,
                grundpreis: 1509.82,
                weiteretausend: 54.35,
              },
              {
                menge: 5000,
                grundpreis: 1580.06,
                weiteretausend: 54.35,
              },
              {
                menge: 10000,
                grundpreis: 1851.83,
                weiteretausend: 54.35,
              },
              {
                menge: 20000,
                grundpreis: 2395.38,
                weiteretausend: 54.35,
              },
              {
                menge: 30000,
                grundpreis: 2938.92,
                weiteretausend: 54.35,
              },
              {
                menge: 40000,
                grundpreis: 3482.47,
                weiteretausend: 54.35,
              },
              {
                menge: 50000,
                grundpreis: 4026.01,
                weiteretausend: 54.35,
              },
              {
                menge: 100000,
                grundpreis: 6743.73,
                weiteretausend: 54.35,
              },
              {
                menge: 150000,
                grundpreis: 9461.45,
                weiteretausend: 54.35,
              },
              {
                menge: 200000,
                grundpreis: 12179.18,
                weiteretausend: 54.35,
              },
              {
                menge: 250000,
                grundpreis: 14896.9,
                weiteretausend: 54.35,
              },
              {
                menge: 300000,
                grundpreis: 17614.62,
                weiteretausend: 54.35,
              },
            ],
          },
          {
            seiten: 20,
            gewicht: 37,
            preise: [
              {
                menge: 2500,
                grundpreis: 1788.56,
                weiteretausend: 61.54,
              },
              {
                menge: 5000,
                grundpreis: 1864.65,
                weiteretausend: 61.54,
              },
              {
                menge: 10000,
                grundpreis: 2172.36,
                weiteretausend: 61.54,
              },
              {
                menge: 20000,
                grundpreis: 2787.78,
                weiteretausend: 61.54,
              },
              {
                menge: 30000,
                grundpreis: 3403.21,
                weiteretausend: 61.54,
              },
              {
                menge: 40000,
                grundpreis: 4018.63,
                weiteretausend: 61.54,
              },
              {
                menge: 50000,
                grundpreis: 4634.05,
                weiteretausend: 61.54,
              },
              {
                menge: 100000,
                grundpreis: 7711.17,
                weiteretausend: 61.54,
              },
              {
                menge: 150000,
                grundpreis: 10788.29,
                weiteretausend: 61.54,
              },
              {
                menge: 200000,
                grundpreis: 13865.4,
                weiteretausend: 61.54,
              },
              {
                menge: 250000,
                grundpreis: 16942.52,
                weiteretausend: 61.54,
              },
              {
                menge: 300000,
                grundpreis: 20019.64,
                weiteretausend: 61.54,
              },
            ],
          },
          {
            seiten: 24,
            gewicht: 45,
            preise: [
              {
                menge: 2500,
                grundpreis: 1828.69,
                weiteretausend: 68.73,
              },
              {
                menge: 5000,
                grundpreis: 1921.0,
                weiteretausend: 68.73,
              },
              {
                menge: 10000,
                grundpreis: 2264.65,
                weiteretausend: 68.73,
              },
              {
                menge: 20000,
                grundpreis: 2951.96,
                weiteretausend: 68.73,
              },
              {
                menge: 30000,
                grundpreis: 3639.26,
                weiteretausend: 68.73,
              },
              {
                menge: 40000,
                grundpreis: 4326.56,
                weiteretausend: 68.73,
              },
              {
                menge: 50000,
                grundpreis: 5013.86,
                weiteretausend: 68.73,
              },
              {
                menge: 100000,
                grundpreis: 8450.38,
                weiteretausend: 68.73,
              },
              {
                menge: 150000,
                grundpreis: 11886.89,
                weiteretausend: 68.73,
              },
              {
                menge: 200000,
                grundpreis: 15323.4,
                weiteretausend: 68.73,
              },
              {
                menge: 250000,
                grundpreis: 18759.91,
                weiteretausend: 68.73,
              },
              {
                menge: 300000,
                grundpreis: 22196.42,
                weiteretausend: 68.73,
              },
            ],
          },
          {
            seiten: 28,
            gewicht: 52,
            preise: [
              {
                menge: 2500,
                grundpreis: 2318.52,
                weiteretausend: 75.93,
              },
              {
                menge: 5000,
                grundpreis: 2407.54,
                weiteretausend: 75.93,
              },
              {
                menge: 10000,
                grundpreis: 2787.2,
                weiteretausend: 75.93,
              },
              {
                menge: 20000,
                grundpreis: 3546.51,
                weiteretausend: 75.93,
              },
              {
                menge: 30000,
                grundpreis: 4305.82,
                weiteretausend: 75.93,
              },
              {
                menge: 40000,
                grundpreis: 5065.14,
                weiteretausend: 75.93,
              },
              {
                menge: 50000,
                grundpreis: 5824.45,
                weiteretausend: 75.93,
              },
              {
                menge: 100000,
                grundpreis: 9621.02,
                weiteretausend: 75.93,
              },
              {
                menge: 150000,
                grundpreis: 13417.58,
                weiteretausend: 75.93,
              },
              {
                menge: 200000,
                grundpreis: 17214.15,
                weiteretausend: 75.93,
              },
              {
                menge: 250000,
                grundpreis: 21010.72,
                weiteretausend: 75.93,
              },
              {
                menge: 300000,
                grundpreis: 24807.29,
                weiteretausend: 75.93,
              },
            ],
          },
          {
            seiten: 32,
            gewicht: 59,
            preise: [
              {
                menge: 2500,
                grundpreis: 1909.0,
                weiteretausend: 83.11,
              },
              {
                menge: 5000,
                grundpreis: 2033.76,
                weiteretausend: 83.11,
              },
              {
                menge: 10000,
                grundpreis: 2449.29,
                weiteretausend: 83.11,
              },
              {
                menge: 20000,
                grundpreis: 3280.35,
                weiteretausend: 83.11,
              },
              {
                menge: 30000,
                grundpreis: 4111.41,
                weiteretausend: 83.11,
              },
              {
                menge: 40000,
                grundpreis: 4942.47,
                weiteretausend: 83.11,
              },
              {
                menge: 50000,
                grundpreis: 5773.53,
                weiteretausend: 83.11,
              },
              {
                menge: 100000,
                grundpreis: 9928.83,
                weiteretausend: 83.11,
              },
              {
                menge: 150000,
                grundpreis: 14084.14,
                weiteretausend: 83.11,
              },
              {
                menge: 200000,
                grundpreis: 18239.44,
                weiteretausend: 83.11,
              },
              {
                menge: 250000,
                grundpreis: 22394.74,
                weiteretausend: 83.11,
              },
              {
                menge: 300000,
                grundpreis: 26550.04,
                weiteretausend: 83.11,
              },
            ],
          },
          {
            seiten: 36,
            gewicht: 67,
            preise: [
              {
                menge: 2500,
                grundpreis: 2747.95,
                weiteretausend: 97.56,
              },
              {
                menge: 5000,
                grundpreis: 2872.38,
                weiteretausend: 97.56,
              },
              {
                menge: 10000,
                grundpreis: 3360.2,
                weiteretausend: 97.56,
              },
              {
                menge: 20000,
                grundpreis: 4335.84,
                weiteretausend: 97.56,
              },
              {
                menge: 30000,
                grundpreis: 5311.48,
                weiteretausend: 97.56,
              },
              {
                menge: 40000,
                grundpreis: 6287.11,
                weiteretausend: 97.56,
              },
              {
                menge: 50000,
                grundpreis: 7262.75,
                weiteretausend: 97.56,
              },
              {
                menge: 100000,
                grundpreis: 12140.94,
                weiteretausend: 97.56,
              },
              {
                menge: 150000,
                grundpreis: 17019.12,
                weiteretausend: 97.56,
              },
              {
                menge: 200000,
                grundpreis: 21897.31,
                weiteretausend: 97.56,
              },
              {
                menge: 250000,
                grundpreis: 26775.49,
                weiteretausend: 97.56,
              },
              {
                menge: 300000,
                grundpreis: 31653.68,
                weiteretausend: 97.56,
              },
            ],
          },
          {
            seiten: 40,
            gewicht: 74,
            preise: [
              {
                menge: 2500,
                grundpreis: 2180.82,
                weiteretausend: 104.76,
              },
              {
                menge: 5000,
                grundpreis: 2347.91,
                weiteretausend: 104.76,
              },
              {
                menge: 10000,
                grundpreis: 2871.73,
                weiteretausend: 104.76,
              },
              {
                menge: 20000,
                grundpreis: 3919.38,
                weiteretausend: 104.76,
              },
              {
                menge: 30000,
                grundpreis: 4967.03,
                weiteretausend: 104.76,
              },
              {
                menge: 40000,
                grundpreis: 6014.68,
                weiteretausend: 104.76,
              },
              {
                menge: 50000,
                grundpreis: 7062.33,
                weiteretausend: 104.76,
              },
              {
                menge: 100000,
                grundpreis: 12300.57,
                weiteretausend: 104.76,
              },
              {
                menge: 150000,
                grundpreis: 17538.81,
                weiteretausend: 104.76,
              },
              {
                menge: 200000,
                grundpreis: 22777.05,
                weiteretausend: 104.76,
              },
              {
                menge: 250000,
                grundpreis: 28015.29,
                weiteretausend: 104.76,
              },
              {
                menge: 300000,
                grundpreis: 33253.53,
                weiteretausend: 104.76,
              },
            ],
          },
          {
            seiten: 44,
            gewicht: 82,
            preise: [
              {
                menge: 2500,
                grundpreis: 3169.08,
                weiteretausend: 111.95,
              },
              {
                menge: 5000,
                grundpreis: 3311.17,
                weiteretausend: 111.95,
              },
              {
                menge: 10000,
                grundpreis: 3870.94,
                weiteretausend: 111.95,
              },
              {
                menge: 20000,
                grundpreis: 4990.46,
                weiteretausend: 111.95,
              },
              {
                menge: 30000,
                grundpreis: 6109.99,
                weiteretausend: 111.95,
              },
              {
                menge: 40000,
                grundpreis: 7229.52,
                weiteretausend: 111.95,
              },
              {
                menge: 50000,
                grundpreis: 8349.05,
                weiteretausend: 111.95,
              },
              {
                menge: 100000,
                grundpreis: 13946.68,
                weiteretausend: 111.95,
              },
              {
                menge: 150000,
                grundpreis: 19544.32,
                weiteretausend: 111.95,
              },
              {
                menge: 200000,
                grundpreis: 25141.96,
                weiteretausend: 111.95,
              },
              {
                menge: 250000,
                grundpreis: 30739.59,
                weiteretausend: 111.95,
              },
              {
                menge: 300000,
                grundpreis: 36337.23,
                weiteretausend: 111.95,
              },
            ],
          },
          {
            seiten: 48,
            gewicht: 89,
            preise: [
              {
                menge: 2500,
                grundpreis: 2303.56,
                weiteretausend: 119.14,
              },
              {
                menge: 5000,
                grundpreis: 2501.26,
                weiteretausend: 119.14,
              },
              {
                menge: 10000,
                grundpreis: 3096.96,
                weiteretausend: 119.14,
              },
              {
                menge: 20000,
                grundpreis: 4288.37,
                weiteretausend: 119.14,
              },
              {
                menge: 30000,
                grundpreis: 5479.78,
                weiteretausend: 119.14,
              },
              {
                menge: 40000,
                grundpreis: 6671.18,
                weiteretausend: 119.14,
              },
              {
                menge: 50000,
                grundpreis: 7862.59,
                weiteretausend: 119.14,
              },
              {
                menge: 100000,
                grundpreis: 13819.62,
                weiteretausend: 119.14,
              },
              {
                menge: 150000,
                grundpreis: 19776.65,
                weiteretausend: 119.14,
              },
              {
                menge: 200000,
                grundpreis: 25733.68,
                weiteretausend: 119.14,
              },
              {
                menge: 250000,
                grundpreis: 31690.72,
                weiteretausend: 119.14,
              },
              {
                menge: 300000,
                grundpreis: 37647.75,
                weiteretausend: 119.14,
              },
            ],
          },
          {
            seiten: 56,
            gewicht: 104,
            preise: [
              {
                menge: 2500,
                grundpreis: 2516.94,
                weiteretausend: 151.85,
              },
              {
                menge: 5000,
                grundpreis: 2787.13,
                weiteretausend: 151.85,
              },
              {
                menge: 10000,
                grundpreis: 3546.38,
                weiteretausend: 151.85,
              },
              {
                menge: 20000,
                grundpreis: 5064.87,
                weiteretausend: 151.85,
              },
              {
                menge: 30000,
                grundpreis: 6583.37,
                weiteretausend: 151.85,
              },
              {
                menge: 40000,
                grundpreis: 8101.86,
                weiteretausend: 151.85,
              },
              {
                menge: 50000,
                grundpreis: 9620.36,
                weiteretausend: 151.85,
              },
              {
                menge: 100000,
                grundpreis: 17212.83,
                weiteretausend: 151.85,
              },
              {
                menge: 150000,
                grundpreis: 24805.31,
                weiteretausend: 151.85,
              },
              {
                menge: 200000,
                grundpreis: 32397.78,
                weiteretausend: 151.85,
              },
              {
                menge: 250000,
                grundpreis: 39990.25,
                weiteretausend: 151.85,
              },
              {
                menge: 300000,
                grundpreis: 47582.73,
                weiteretausend: 151.85,
              },
            ],
          },
          {
            seiten: 64,
            gewicht: 119,
            preise: [
              {
                menge: 2500,
                grundpreis: 2703.66,
                weiteretausend: 166.24,
              },
              {
                menge: 5000,
                grundpreis: 3001.71,
                weiteretausend: 166.24,
              },
              {
                menge: 10000,
                grundpreis: 3832.9,
                weiteretausend: 166.24,
              },
              {
                menge: 20000,
                grundpreis: 5495.29,
                weiteretausend: 166.24,
              },
              {
                menge: 30000,
                grundpreis: 7157.67,
                weiteretausend: 166.24,
              },
              {
                menge: 40000,
                grundpreis: 8820.06,
                weiteretausend: 166.24,
              },
              {
                menge: 50000,
                grundpreis: 10482.44,
                weiteretausend: 166.24,
              },
              {
                menge: 100000,
                grundpreis: 18794.37,
                weiteretausend: 166.24,
              },
              {
                menge: 150000,
                grundpreis: 27106.29,
                weiteretausend: 166.24,
              },
              {
                menge: 200000,
                grundpreis: 35418.22,
                weiteretausend: 166.24,
              },
              {
                menge: 250000,
                grundpreis: 43730.14,
                weiteretausend: 166.24,
              },
              {
                menge: 300000,
                grundpreis: 52042.07,
                weiteretausend: 166.24,
              },
            ],
          },
        ],
      },
      'Rota 80.0g': {
        type: 'paged',
        bild: 'produkt-beilage.png',
        kategoriename: 'Beilage',
        verarbeitung: 'beilagen',
        druckkosten: 'seiten-gewicht-gestaffelt',
        minmenge: 2500,
        items: [
          {
            seiten: 4,
            gewicht: 11,
            preise: [
              {
                menge: 2500,
                grundpreis: 1681.6,
                weiteretausend: 51.68,
              },
              {
                menge: 5000,
                grundpreis: 1737.7,
                weiteretausend: 51.68,
              },
              {
                menge: 10000,
                grundpreis: 1996.11,
                weiteretausend: 51.68,
              },
              {
                menge: 20000,
                grundpreis: 2512.94,
                weiteretausend: 51.68,
              },
              {
                menge: 30000,
                grundpreis: 3029.76,
                weiteretausend: 51.68,
              },
              {
                menge: 40000,
                grundpreis: 3546.59,
                weiteretausend: 51.68,
              },
              {
                menge: 50000,
                grundpreis: 4063.42,
                weiteretausend: 51.68,
              },
              {
                menge: 100000,
                grundpreis: 6647.55,
                weiteretausend: 51.68,
              },
              {
                menge: 150000,
                grundpreis: 9231.68,
                weiteretausend: 51.68,
              },
              {
                menge: 200000,
                grundpreis: 11815.82,
                weiteretausend: 51.68,
              },
              {
                menge: 250000,
                grundpreis: 14399.95,
                weiteretausend: 51.68,
              },
              {
                menge: 300000,
                grundpreis: 16984.08,
                weiteretausend: 51.68,
              },
            ],
          },
          {
            seiten: 8,
            gewicht: 22,
            preise: [
              {
                menge: 2500,
                grundpreis: 1762.7,
                weiteretausend: 73.02,
              },
              {
                menge: 5000,
                grundpreis: 1868.6,
                weiteretausend: 73.02,
              },
              {
                menge: 10000,
                grundpreis: 2233.69,
                weiteretausend: 73.02,
              },
              {
                menge: 20000,
                grundpreis: 2963.86,
                weiteretausend: 73.02,
              },
              {
                menge: 30000,
                grundpreis: 3694.03,
                weiteretausend: 73.02,
              },
              {
                menge: 40000,
                grundpreis: 4424.21,
                weiteretausend: 73.02,
              },
              {
                menge: 50000,
                grundpreis: 5154.38,
                weiteretausend: 73.02,
              },
              {
                menge: 100000,
                grundpreis: 8805.24,
                weiteretausend: 73.02,
              },
              {
                menge: 150000,
                grundpreis: 12456.11,
                weiteretausend: 73.02,
              },
              {
                menge: 200000,
                grundpreis: 16106.98,
                weiteretausend: 73.02,
              },
              {
                menge: 250000,
                grundpreis: 19757.84,
                weiteretausend: 73.02,
              },
              {
                menge: 300000,
                grundpreis: 23408.71,
                weiteretausend: 73.02,
              },
            ],
          },
          {
            seiten: 12,
            gewicht: 32,
            preise: [
              {
                menge: 2500,
                grundpreis: 1843.79,
                weiteretausend: 94.35,
              },
              {
                menge: 5000,
                grundpreis: 1999.5,
                weiteretausend: 94.35,
              },
              {
                menge: 10000,
                grundpreis: 2471.26,
                weiteretausend: 94.35,
              },
              {
                menge: 20000,
                grundpreis: 3414.78,
                weiteretausend: 94.35,
              },
              {
                menge: 30000,
                grundpreis: 4358.3,
                weiteretausend: 94.35,
              },
              {
                menge: 40000,
                grundpreis: 5301.82,
                weiteretausend: 94.35,
              },
              {
                menge: 50000,
                grundpreis: 6245.34,
                weiteretausend: 94.35,
              },
              {
                menge: 100000,
                grundpreis: 10962.94,
                weiteretausend: 94.35,
              },
              {
                menge: 150000,
                grundpreis: 15680.54,
                weiteretausend: 94.35,
              },
              {
                menge: 200000,
                grundpreis: 20398.14,
                weiteretausend: 94.35,
              },
              {
                menge: 250000,
                grundpreis: 25115.73,
                weiteretausend: 94.35,
              },
              {
                menge: 300000,
                grundpreis: 29833.33,
                weiteretausend: 94.35,
              },
            ],
          },
          {
            seiten: 16,
            gewicht: 43,
            preise: [
              {
                menge: 2500,
                grundpreis: 1924.88,
                weiteretausend: 115.69,
              },
              {
                menge: 5000,
                grundpreis: 2130.41,
                weiteretausend: 115.69,
              },
              {
                menge: 10000,
                grundpreis: 2708.84,
                weiteretausend: 115.69,
              },
              {
                menge: 20000,
                grundpreis: 3865.71,
                weiteretausend: 115.69,
              },
              {
                menge: 30000,
                grundpreis: 5022.57,
                weiteretausend: 115.69,
              },
              {
                menge: 40000,
                grundpreis: 6179.44,
                weiteretausend: 115.69,
              },
              {
                menge: 50000,
                grundpreis: 7336.31,
                weiteretausend: 115.69,
              },
              {
                menge: 100000,
                grundpreis: 13120.64,
                weiteretausend: 115.69,
              },
              {
                menge: 150000,
                grundpreis: 18904.97,
                weiteretausend: 115.69,
              },
              {
                menge: 200000,
                grundpreis: 24689.3,
                weiteretausend: 115.69,
              },
              {
                menge: 250000,
                grundpreis: 30473.63,
                weiteretausend: 115.69,
              },
              {
                menge: 300000,
                grundpreis: 36257.96,
                weiteretausend: 115.69,
              },
            ],
          },
          {
            seiten: 20,
            gewicht: 54,
            preise: [
              {
                menge: 2500,
                grundpreis: 2289.0,
                weiteretausend: 137.01,
              },
              {
                menge: 5000,
                grundpreis: 2532.0,
                weiteretausend: 137.01,
              },
              {
                menge: 10000,
                grundpreis: 3217.04,
                weiteretausend: 137.01,
              },
              {
                menge: 20000,
                grundpreis: 4587.12,
                weiteretausend: 137.01,
              },
              {
                menge: 30000,
                grundpreis: 5957.2,
                weiteretausend: 137.01,
              },
              {
                menge: 40000,
                grundpreis: 7327.28,
                weiteretausend: 137.01,
              },
              {
                menge: 50000,
                grundpreis: 8697.36,
                weiteretausend: 137.01,
              },
              {
                menge: 100000,
                grundpreis: 15547.77,
                weiteretausend: 137.01,
              },
              {
                menge: 150000,
                grundpreis: 22398.17,
                weiteretausend: 137.01,
              },
              {
                menge: 200000,
                grundpreis: 29248.57,
                weiteretausend: 137.01,
              },
              {
                menge: 250000,
                grundpreis: 36098.97,
                weiteretausend: 137.01,
              },
              {
                menge: 300000,
                grundpreis: 42949.37,
                weiteretausend: 137.01,
              },
            ],
          },
          {
            seiten: 24,
            gewicht: 65,
            preise: [
              {
                menge: 2500,
                grundpreis: 2370.1,
                weiteretausend: 158.34,
              },
              {
                menge: 5000,
                grundpreis: 2662.91,
                weiteretausend: 158.34,
              },
              {
                menge: 10000,
                grundpreis: 3454.62,
                weiteretausend: 158.34,
              },
              {
                menge: 20000,
                grundpreis: 5038.05,
                weiteretausend: 158.34,
              },
              {
                menge: 30000,
                grundpreis: 6621.47,
                weiteretausend: 158.34,
              },
              {
                menge: 40000,
                grundpreis: 8204.9,
                weiteretausend: 158.34,
              },
              {
                menge: 50000,
                grundpreis: 9788.33,
                weiteretausend: 158.34,
              },
              {
                menge: 100000,
                grundpreis: 17705.46,
                weiteretausend: 158.34,
              },
              {
                menge: 150000,
                grundpreis: 25622.6,
                weiteretausend: 158.34,
              },
              {
                menge: 200000,
                grundpreis: 33539.73,
                weiteretausend: 158.34,
              },
              {
                menge: 250000,
                grundpreis: 41456.86,
                weiteretausend: 158.34,
              },
              {
                menge: 300000,
                grundpreis: 49374.0,
                weiteretausend: 158.34,
              },
            ],
          },
          {
            seiten: 32,
            gewicht: 86,
            preise: [
              {
                menge: 2500,
                grundpreis: 2532.28,
                weiteretausend: 201.01,
              },
              {
                menge: 5000,
                grundpreis: 2924.71,
                weiteretausend: 201.01,
              },
              {
                menge: 10000,
                grundpreis: 3929.77,
                weiteretausend: 201.01,
              },
              {
                menge: 20000,
                grundpreis: 5939.89,
                weiteretausend: 201.01,
              },
              {
                menge: 30000,
                grundpreis: 7950.01,
                weiteretausend: 201.01,
              },
              {
                menge: 40000,
                grundpreis: 9960.13,
                weiteretausend: 201.01,
              },
              {
                menge: 50000,
                grundpreis: 11970.25,
                weiteretausend: 201.01,
              },
              {
                menge: 100000,
                grundpreis: 22020.85,
                weiteretausend: 201.01,
              },
              {
                menge: 150000,
                grundpreis: 32071.45,
                weiteretausend: 201.01,
              },
              {
                menge: 200000,
                grundpreis: 42122.05,
                weiteretausend: 201.01,
              },
              {
                menge: 250000,
                grundpreis: 52172.65,
                weiteretausend: 201.01,
              },
              {
                menge: 300000,
                grundpreis: 62223.25,
                weiteretausend: 201.01,
              },
            ],
          },
          {
            seiten: 40,
            gewicht: 108,
            preise: [
              {
                menge: 2500,
                grundpreis: 3625.87,
                weiteretausend: 252.3,
              },
              {
                menge: 5000,
                grundpreis: 4098.98,
                weiteretausend: 252.3,
              },
              {
                menge: 10000,
                grundpreis: 5360.47,
                weiteretausend: 252.3,
              },
              {
                menge: 20000,
                grundpreis: 7883.46,
                weiteretausend: 252.3,
              },
              {
                menge: 30000,
                grundpreis: 10406.46,
                weiteretausend: 252.3,
              },
              {
                menge: 40000,
                grundpreis: 12929.45,
                weiteretausend: 252.3,
              },
              {
                menge: 50000,
                grundpreis: 15452.44,
                weiteretausend: 252.3,
              },
              {
                menge: 100000,
                grundpreis: 28067.41,
                weiteretausend: 252.3,
              },
              {
                menge: 150000,
                grundpreis: 40682.37,
                weiteretausend: 252.3,
              },
              {
                menge: 200000,
                grundpreis: 53297.33,
                weiteretausend: 252.3,
              },
              {
                menge: 250000,
                grundpreis: 65912.3,
                weiteretausend: 252.3,
              },
              {
                menge: 300000,
                grundpreis: 78527.26,
                weiteretausend: 252.3,
              },
            ],
          },
          {
            seiten: 48,
            gewicht: 130,
            preise: [
              {
                menge: 2500,
                grundpreis: 3801.84,
                weiteretausend: 300.24,
              },
              {
                menge: 5000,
                grundpreis: 4387.15,
                weiteretausend: 300.24,
              },
              {
                menge: 10000,
                grundpreis: 5888.36,
                weiteretausend: 300.24,
              },
              {
                menge: 20000,
                grundpreis: 8890.79,
                weiteretausend: 300.24,
              },
              {
                menge: 30000,
                grundpreis: 11893.21,
                weiteretausend: 300.24,
              },
              {
                menge: 40000,
                grundpreis: 14895.64,
                weiteretausend: 300.24,
              },
              {
                menge: 50000,
                grundpreis: 17898.06,
                weiteretausend: 300.24,
              },
              {
                menge: 100000,
                grundpreis: 32910.19,
                weiteretausend: 300.24,
              },
              {
                menge: 150000,
                grundpreis: 47922.31,
                weiteretausend: 300.24,
              },
              {
                menge: 200000,
                grundpreis: 62934.43,
                weiteretausend: 300.24,
              },
              {
                menge: 250000,
                grundpreis: 77946.56,
                weiteretausend: 300.24,
              },
              {
                menge: 300000,
                grundpreis: 92958.68,
                weiteretausend: 300.24,
              },
            ],
          },
        ],
      },
      'LWC glänzend': {
        type: 'paged',
        bild: 'produkt-beilage.png',
        kategoriename: 'Beilage',
        verarbeitung: 'beilagen',
        druckkosten: 'seiten-gewicht-gestaffelt',
        minmenge: 2500,
        items: [
          {
            seiten: 8,
            gewicht: 17,
            preise: [
              {
                menge: 2500,
                grundpreis: 938.57,
                weiteretausend: 30.43,
              },
              {
                menge: 5000,
                grundpreis: 1014.64,
                weiteretausend: 30.43,
              },
              {
                menge: 10000,
                grundpreis: 1166.79,
                weiteretausend: 30.43,
              },
              {
                menge: 20000,
                grundpreis: 1471.08,
                weiteretausend: 30.43,
              },
              {
                menge: 30000,
                grundpreis: 1775.37,
                weiteretausend: 30.43,
              },
              {
                menge: 40000,
                grundpreis: 2079.66,
                weiteretausend: 30.43,
              },
              {
                menge: 50000,
                grundpreis: 2383.95,
                weiteretausend: 30.43,
              },
              {
                menge: 100000,
                grundpreis: 3905.4,
                weiteretausend: 30.43,
              },
              {
                menge: 150000,
                grundpreis: 5426.85,
                weiteretausend: 30.43,
              },
              {
                menge: 200000,
                grundpreis: 6948.3,
                weiteretausend: 30.43,
              },
              {
                menge: 250000,
                grundpreis: 8469.74,
                weiteretausend: 30.43,
              },
              {
                menge: 300000,
                grundpreis: 9991.19,
                weiteretausend: 30.43,
              },
            ],
          },
          {
            seiten: 12,
            gewicht: 26,
            preise: [
              {
                menge: 2500,
                grundpreis: 1012.29,
                weiteretausend: 46.11,
              },
              {
                menge: 5000,
                grundpreis: 1127.57,
                weiteretausend: 46.11,
              },
              {
                menge: 10000,
                grundpreis: 1358.14,
                weiteretausend: 46.11,
              },
              {
                menge: 20000,
                grundpreis: 1819.28,
                weiteretausend: 46.11,
              },
              {
                menge: 30000,
                grundpreis: 2280.42,
                weiteretausend: 46.11,
              },
              {
                menge: 40000,
                grundpreis: 2741.56,
                weiteretausend: 46.11,
              },
              {
                menge: 50000,
                grundpreis: 3202.7,
                weiteretausend: 46.11,
              },
              {
                menge: 100000,
                grundpreis: 5508.41,
                weiteretausend: 46.11,
              },
              {
                menge: 150000,
                grundpreis: 7814.11,
                weiteretausend: 46.11,
              },
              {
                menge: 200000,
                grundpreis: 10119.81,
                weiteretausend: 46.11,
              },
              {
                menge: 250000,
                grundpreis: 12425.52,
                weiteretausend: 46.11,
              },
              {
                menge: 300000,
                grundpreis: 14731.22,
                weiteretausend: 46.11,
              },
            ],
          },
          {
            seiten: 16,
            gewicht: 35,
            preise: [
              {
                menge: 2500,
                grundpreis: 1009.37,
                weiteretausend: 58.75,
              },
              {
                menge: 5000,
                grundpreis: 1156.24,
                weiteretausend: 58.75,
              },
              {
                menge: 10000,
                grundpreis: 1449.98,
                weiteretausend: 58.75,
              },
              {
                menge: 20000,
                grundpreis: 2037.45,
                weiteretausend: 58.75,
              },
              {
                menge: 30000,
                grundpreis: 2624.93,
                weiteretausend: 58.75,
              },
              {
                menge: 40000,
                grundpreis: 3212.41,
                weiteretausend: 58.75,
              },
              {
                menge: 50000,
                grundpreis: 3799.88,
                weiteretausend: 58.75,
              },
              {
                menge: 100000,
                grundpreis: 6737.27,
                weiteretausend: 58.75,
              },
              {
                menge: 150000,
                grundpreis: 9674.65,
                weiteretausend: 58.75,
              },
              {
                menge: 200000,
                grundpreis: 12612.04,
                weiteretausend: 58.75,
              },
              {
                menge: 250000,
                grundpreis: 15549.42,
                weiteretausend: 58.75,
              },
              {
                menge: 300000,
                grundpreis: 18486.8,
                weiteretausend: 58.75,
              },
            ],
          },
          {
            seiten: 20,
            gewicht: 44,
            preise: [
              {
                menge: 2500,
                grundpreis: 1734.53,
                weiteretausend: 72.81,
              },
              {
                menge: 5000,
                grundpreis: 1916.56,
                weiteretausend: 72.81,
              },
              {
                menge: 10000,
                grundpreis: 2280.62,
                weiteretausend: 72.81,
              },
              {
                menge: 20000,
                grundpreis: 3008.74,
                weiteretausend: 72.81,
              },
              {
                menge: 30000,
                grundpreis: 3736.87,
                weiteretausend: 72.81,
              },
              {
                menge: 40000,
                grundpreis: 4464.99,
                weiteretausend: 72.81,
              },
              {
                menge: 50000,
                grundpreis: 5193.11,
                weiteretausend: 72.81,
              },
              {
                menge: 100000,
                grundpreis: 8833.72,
                weiteretausend: 72.81,
              },
              {
                menge: 150000,
                grundpreis: 12474.33,
                weiteretausend: 72.81,
              },
              {
                menge: 200000,
                grundpreis: 16114.94,
                weiteretausend: 72.81,
              },
              {
                menge: 250000,
                grundpreis: 19755.54,
                weiteretausend: 72.81,
              },
              {
                menge: 300000,
                grundpreis: 23396.15,
                weiteretausend: 72.81,
              },
            ],
          },
          {
            seiten: 24,
            gewicht: 52,
            preise: [
              {
                menge: 2500,
                grundpreis: 1845.33,
                weiteretausend: 84.93,
              },
              {
                menge: 5000,
                grundpreis: 2057.67,
                weiteretausend: 84.93,
              },
              {
                menge: 10000,
                grundpreis: 2482.33,
                weiteretausend: 84.93,
              },
              {
                menge: 20000,
                grundpreis: 3331.67,
                weiteretausend: 84.93,
              },
              {
                menge: 30000,
                grundpreis: 4181.0,
                weiteretausend: 84.93,
              },
              {
                menge: 40000,
                grundpreis: 5030.33,
                weiteretausend: 84.93,
              },
              {
                menge: 50000,
                grundpreis: 5879.67,
                weiteretausend: 84.93,
              },
              {
                menge: 100000,
                grundpreis: 10126.34,
                weiteretausend: 84.93,
              },
              {
                menge: 150000,
                grundpreis: 14373.01,
                weiteretausend: 84.93,
              },
              {
                menge: 200000,
                grundpreis: 18619.67,
                weiteretausend: 84.93,
              },
              {
                menge: 250000,
                grundpreis: 22866.34,
                weiteretausend: 84.93,
              },
              {
                menge: 300000,
                grundpreis: 27113.01,
                weiteretausend: 84.93,
              },
            ],
          },
          {
            seiten: 28,
            gewicht: 61,
            preise: [
              {
                menge: 2500,
                grundpreis: 2397.35,
                weiteretausend: 107.94,
              },
              {
                menge: 5000,
                grundpreis: 2667.2,
                weiteretausend: 107.94,
              },
              {
                menge: 10000,
                grundpreis: 3206.89,
                weiteretausend: 107.94,
              },
              {
                menge: 20000,
                grundpreis: 4286.28,
                weiteretausend: 107.94,
              },
              {
                menge: 30000,
                grundpreis: 5365.68,
                weiteretausend: 107.94,
              },
              {
                menge: 40000,
                grundpreis: 6445.07,
                weiteretausend: 107.94,
              },
              {
                menge: 50000,
                grundpreis: 7524.46,
                weiteretausend: 107.94,
              },
              {
                menge: 100000,
                grundpreis: 12921.42,
                weiteretausend: 107.94,
              },
              {
                menge: 150000,
                grundpreis: 18318.38,
                weiteretausend: 107.94,
              },
              {
                menge: 200000,
                grundpreis: 23715.34,
                weiteretausend: 107.94,
              },
              {
                menge: 250000,
                grundpreis: 29112.3,
                weiteretausend: 107.94,
              },
              {
                menge: 300000,
                grundpreis: 34509.26,
                weiteretausend: 107.94,
              },
            ],
          },
          {
            seiten: 32,
            gewicht: 70,
            preise: [
              {
                menge: 2500,
                grundpreis: 2341.33,
                weiteretausend: 117.73,
              },
              {
                menge: 5000,
                grundpreis: 2635.66,
                weiteretausend: 117.73,
              },
              {
                menge: 10000,
                grundpreis: 3224.32,
                weiteretausend: 117.73,
              },
              {
                menge: 20000,
                grundpreis: 4401.65,
                weiteretausend: 117.73,
              },
              {
                menge: 30000,
                grundpreis: 5578.97,
                weiteretausend: 117.73,
              },
              {
                menge: 40000,
                grundpreis: 6756.29,
                weiteretausend: 117.73,
              },
              {
                menge: 50000,
                grundpreis: 7933.62,
                weiteretausend: 117.73,
              },
              {
                menge: 100000,
                grundpreis: 13820.23,
                weiteretausend: 117.73,
              },
              {
                menge: 150000,
                grundpreis: 19706.85,
                weiteretausend: 117.73,
              },
              {
                menge: 200000,
                grundpreis: 25593.47,
                weiteretausend: 117.73,
              },
              {
                menge: 250000,
                grundpreis: 31480.09,
                weiteretausend: 117.73,
              },
              {
                menge: 300000,
                grundpreis: 37366.7,
                weiteretausend: 117.73,
              },
            ],
          },
          {
            seiten: 36,
            gewicht: 78,
            preise: [
              {
                menge: 2500,
                grundpreis: 2789.48,
                weiteretausend: 135.99,
              },
              {
                menge: 5000,
                grundpreis: 3129.46,
                weiteretausend: 135.99,
              },
              {
                menge: 10000,
                grundpreis: 3809.42,
                weiteretausend: 135.99,
              },
              {
                menge: 20000,
                grundpreis: 5169.34,
                weiteretausend: 135.99,
              },
              {
                menge: 30000,
                grundpreis: 6529.26,
                weiteretausend: 135.99,
              },
              {
                menge: 40000,
                grundpreis: 7889.18,
                weiteretausend: 135.99,
              },
              {
                menge: 50000,
                grundpreis: 9249.1,
                weiteretausend: 135.99,
              },
              {
                menge: 100000,
                grundpreis: 16048.7,
                weiteretausend: 135.99,
              },
              {
                menge: 150000,
                grundpreis: 22848.29,
                weiteretausend: 135.99,
              },
              {
                menge: 200000,
                grundpreis: 29647.89,
                weiteretausend: 135.99,
              },
              {
                menge: 250000,
                grundpreis: 36447.49,
                weiteretausend: 135.99,
              },
              {
                menge: 300000,
                grundpreis: 43247.09,
                weiteretausend: 135.99,
              },
            ],
          },
          {
            seiten: 40,
            gewicht: 87,
            preise: [
              {
                menge: 2500,
                grundpreis: 2058.39,
                weiteretausend: 142.56,
              },
              {
                menge: 5000,
                grundpreis: 2414.78,
                weiteretausend: 142.56,
              },
              {
                menge: 10000,
                grundpreis: 3127.57,
                weiteretausend: 142.56,
              },
              {
                menge: 20000,
                grundpreis: 4553.13,
                weiteretausend: 142.56,
              },
              {
                menge: 30000,
                grundpreis: 5978.7,
                weiteretausend: 142.56,
              },
              {
                menge: 40000,
                grundpreis: 7404.27,
                weiteretausend: 142.56,
              },
              {
                menge: 50000,
                grundpreis: 8829.83,
                weiteretausend: 142.56,
              },
              {
                menge: 100000,
                grundpreis: 15957.67,
                weiteretausend: 142.56,
              },
              {
                menge: 150000,
                grundpreis: 23085.5,
                weiteretausend: 142.56,
              },
              {
                menge: 200000,
                grundpreis: 30213.33,
                weiteretausend: 142.56,
              },
              {
                menge: 250000,
                grundpreis: 37341.16,
                weiteretausend: 142.56,
              },
              {
                menge: 300000,
                grundpreis: 49983.2,
                weiteretausend: 142.56,
              },
            ],
          },
          {
            seiten: 44,
            gewicht: 96,
            preise: [
              {
                menge: 2500,
                grundpreis: 1077.35,
                weiteretausend: 179.4,
              },
              {
                menge: 5000,
                grundpreis: 1525.85,
                weiteretausend: 179.4,
              },
              {
                menge: 10000,
                grundpreis: 2422.85,
                weiteretausend: 179.4,
              },
              {
                menge: 20000,
                grundpreis: 4216.85,
                weiteretausend: 179.4,
              },
              {
                menge: 30000,
                grundpreis: 6010.85,
                weiteretausend: 179.4,
              },
              {
                menge: 40000,
                grundpreis: 7804.84,
                weiteretausend: 179.4,
              },
              {
                menge: 50000,
                grundpreis: 9598.84,
                weiteretausend: 179.4,
              },
              {
                menge: 100000,
                grundpreis: 18568.84,
                weiteretausend: 179.4,
              },
              {
                menge: 150000,
                grundpreis: 27538.84,
                weiteretausend: 179.4,
              },
              {
                menge: 200000,
                grundpreis: 36508.83,
                weiteretausend: 179.4,
              },
              {
                menge: 250000,
                grundpreis: 45478.83,
                weiteretausend: 179.4,
              },
              {
                menge: 300000,
                grundpreis: 54448.82,
                weiteretausend: 179.4,
              },
            ],
          },
          {
            seiten: 48,
            gewicht: 105,
            preise: [
              {
                menge: 2500,
                grundpreis: 2089.76,
                weiteretausend: 168.91,
              },
              {
                menge: 5000,
                grundpreis: 2512.03,
                weiteretausend: 168.91,
              },
              {
                menge: 10000,
                grundpreis: 3356.55,
                weiteretausend: 168.91,
              },
              {
                menge: 20000,
                grundpreis: 5045.61,
                weiteretausend: 168.91,
              },
              {
                menge: 30000,
                grundpreis: 6734.66,
                weiteretausend: 168.91,
              },
              {
                menge: 40000,
                grundpreis: 8423.72,
                weiteretausend: 168.91,
              },
              {
                menge: 50000,
                grundpreis: 10112.77,
                weiteretausend: 168.91,
              },
              {
                menge: 100000,
                grundpreis: 18558.04,
                weiteretausend: 168.91,
              },
              {
                menge: 150000,
                grundpreis: 27003.31,
                weiteretausend: 168.91,
              },
              {
                menge: 200000,
                grundpreis: 35448.58,
                weiteretausend: 168.91,
              },
              {
                menge: 250000,
                grundpreis: 43893.85,
                weiteretausend: 168.91,
              },
              {
                menge: 300000,
                grundpreis: 52339.11,
                weiteretausend: 168.91,
              },
            ],
          },
          {
            seiten: 56,
            gewicht: 122,
            preise: [
              {
                menge: 2500,
                grundpreis: 2496.04,
                weiteretausend: 207.22,
              },
              {
                menge: 5000,
                grundpreis: 3014.08,
                weiteretausend: 207.22,
              },
              {
                menge: 10000,
                grundpreis: 4050.17,
                weiteretausend: 207.22,
              },
              {
                menge: 20000,
                grundpreis: 6122.34,
                weiteretausend: 207.22,
              },
              {
                menge: 30000,
                grundpreis: 8194.51,
                weiteretausend: 207.22,
              },
              {
                menge: 40000,
                grundpreis: 10266.68,
                weiteretausend: 207.22,
              },
              {
                menge: 50000,
                grundpreis: 12338.85,
                weiteretausend: 207.22,
              },
              {
                menge: 100000,
                grundpreis: 22699.7,
                weiteretausend: 207.22,
              },
              {
                menge: 150000,
                grundpreis: 33060.55,
                weiteretausend: 207.22,
              },
              {
                menge: 200000,
                grundpreis: 43421.4,
                weiteretausend: 207.22,
              },
              {
                menge: 250000,
                grundpreis: 53782.24,
                weiteretausend: 207.22,
              },
              {
                menge: 300000,
                grundpreis: 64143.09,
                weiteretausend: 207.22,
              },
            ],
          },
          {
            seiten: 64,
            gewicht: 140,
            preise: [
              {
                menge: 2500,
                grundpreis: 2708.12,
                weiteretausend: 234.55,
              },
              {
                menge: 5000,
                grundpreis: 3294.5,
                weiteretausend: 234.55,
              },
              {
                menge: 10000,
                grundpreis: 4467.24,
                weiteretausend: 234.55,
              },
              {
                menge: 20000,
                grundpreis: 6812.73,
                weiteretausend: 234.55,
              },
              {
                menge: 30000,
                grundpreis: 9158.22,
                weiteretausend: 234.55,
              },
              {
                menge: 40000,
                grundpreis: 11503.71,
                weiteretausend: 234.55,
              },
              {
                menge: 50000,
                grundpreis: 13849.2,
                weiteretausend: 234.55,
              },
              {
                menge: 100000,
                grundpreis: 25576.66,
                weiteretausend: 234.55,
              },
              {
                menge: 150000,
                grundpreis: 37304.11,
                weiteretausend: 234.55,
              },
              {
                menge: 200000,
                grundpreis: 49031.56,
                weiteretausend: 234.55,
              },
              {
                menge: 250000,
                grundpreis: 60759.01,
                weiteretausend: 234.55,
              },
              {
                menge: 300000,
                grundpreis: 72486.47,
                weiteretausend: 234.55,
              },
            ],
          },
          {
            seiten: 72,
            gewicht: 158,
            preise: [
              {
                menge: 2500,
                grundpreis: 3398.29,
                weiteretausend: 259.92,
              },
              {
                menge: 5000,
                grundpreis: 4048.08,
                weiteretausend: 259.92,
              },
              {
                menge: 10000,
                grundpreis: 5347.66,
                weiteretausend: 259.92,
              },
              {
                menge: 20000,
                grundpreis: 7946.81,
                weiteretausend: 259.92,
              },
              {
                menge: 30000,
                grundpreis: 10545.97,
                weiteretausend: 259.92,
              },
              {
                menge: 40000,
                grundpreis: 13145.12,
                weiteretausend: 259.92,
              },
              {
                menge: 50000,
                grundpreis: 15744.28,
                weiteretausend: 259.92,
              },
              {
                menge: 100000,
                grundpreis: 28740.06,
                weiteretausend: 259.92,
              },
              {
                menge: 150000,
                grundpreis: 41735.84,
                weiteretausend: 259.92,
              },
              {
                menge: 200000,
                grundpreis: 54731.61,
                weiteretausend: 259.92,
              },
              {
                menge: 250000,
                grundpreis: 67727.39,
                weiteretausend: 259.92,
              },
              {
                menge: 300000,
                grundpreis: 80723.17,
                weiteretausend: 259.92,
              },
            ],
          },
        ],
      },
      'LWC matt': {
        type: 'paged',
        bild: 'produkt-beilage.png',
        kategoriename: 'Beilage',
        verarbeitung: 'beilagen',
        druckkosten: 'seiten-gewicht-gestaffelt',
        minmenge: 2500,
        items: [
          {
            seiten: 8,
            gewicht: 16,
            preise: [
              {
                menge: 2500,
                grundpreis: 936.51,
                weiteretausend: 29.6,
              },
              {
                menge: 5000,
                grundpreis: 1010.51,
                weiteretausend: 29.6,
              },
              {
                menge: 10000,
                grundpreis: 1158.52,
                weiteretausend: 29.6,
              },
              {
                menge: 20000,
                grundpreis: 1454.54,
                weiteretausend: 29.6,
              },
              {
                menge: 30000,
                grundpreis: 1750.56,
                weiteretausend: 29.6,
              },
              {
                menge: 40000,
                grundpreis: 2046.58,
                weiteretausend: 29.6,
              },
              {
                menge: 50000,
                grundpreis: 2342.6,
                weiteretausend: 29.6,
              },
              {
                menge: 100000,
                grundpreis: 3822.7,
                weiteretausend: 29.6,
              },
              {
                menge: 150000,
                grundpreis: 5302.8,
                weiteretausend: 29.6,
              },
              {
                menge: 200000,
                grundpreis: 6782.91,
                weiteretausend: 29.6,
              },
              {
                menge: 250000,
                grundpreis: 8263.01,
                weiteretausend: 29.6,
              },
              {
                menge: 300000,
                grundpreis: 9743.11,
                weiteretausend: 29.6,
              },
            ],
          },
          {
            seiten: 12,
            gewicht: 24,
            preise: [
              {
                menge: 2500,
                grundpreis: 1009.24,
                weiteretausend: 44.9,
              },
              {
                menge: 5000,
                grundpreis: 1121.48,
                weiteretausend: 44.9,
              },
              {
                menge: 10000,
                grundpreis: 1345.97,
                weiteretausend: 44.9,
              },
              {
                menge: 20000,
                grundpreis: 1794.93,
                weiteretausend: 44.9,
              },
              {
                menge: 30000,
                grundpreis: 2243.9,
                weiteretausend: 44.9,
              },
              {
                menge: 40000,
                grundpreis: 2692.87,
                weiteretausend: 44.9,
              },
              {
                menge: 50000,
                grundpreis: 3141.83,
                weiteretausend: 44.9,
              },
              {
                menge: 100000,
                grundpreis: 5386.67,
                weiteretausend: 44.9,
              },
              {
                menge: 150000,
                grundpreis: 7631.5,
                weiteretausend: 44.9,
              },
              {
                menge: 200000,
                grundpreis: 9876.33,
                weiteretausend: 44.9,
              },
              {
                menge: 250000,
                grundpreis: 12121.17,
                weiteretausend: 44.9,
              },
              {
                menge: 300000,
                grundpreis: 14366.0,
                weiteretausend: 44.9,
              },
            ],
          },
          {
            seiten: 16,
            gewicht: 32,
            preise: [
              {
                menge: 2500,
                grundpreis: 1005.33,
                weiteretausend: 57.13,
              },
              {
                menge: 5000,
                grundpreis: 1148.16,
                weiteretausend: 57.13,
              },
              {
                menge: 10000,
                grundpreis: 1433.82,
                weiteretausend: 57.13,
              },
              {
                menge: 20000,
                grundpreis: 2005.14,
                weiteretausend: 57.13,
              },
              {
                menge: 30000,
                grundpreis: 2576.47,
                weiteretausend: 57.13,
              },
              {
                menge: 40000,
                grundpreis: 3147.79,
                weiteretausend: 57.13,
              },
              {
                menge: 50000,
                grundpreis: 3719.11,
                weiteretausend: 57.13,
              },
              {
                menge: 100000,
                grundpreis: 6575.72,
                weiteretausend: 57.13,
              },
              {
                menge: 150000,
                grundpreis: 9432.34,
                weiteretausend: 57.13,
              },
              {
                menge: 200000,
                grundpreis: 12288.95,
                weiteretausend: 57.13,
              },
              {
                menge: 250000,
                grundpreis: 15145.56,
                weiteretausend: 57.13,
              },
              {
                menge: 300000,
                grundpreis: 18002.17,
                weiteretausend: 57.13,
              },
            ],
          },
          {
            seiten: 20,
            gewicht: 41,
            preise: [
              {
                menge: 2500,
                grundpreis: 1729.34,
                weiteretausend: 70.74,
              },
              {
                menge: 5000,
                grundpreis: 1906.18,
                weiteretausend: 70.74,
              },
              {
                menge: 10000,
                grundpreis: 2259.86,
                weiteretausend: 70.74,
              },
              {
                menge: 20000,
                grundpreis: 2967.21,
                weiteretausend: 70.74,
              },
              {
                menge: 30000,
                grundpreis: 3674.57,
                weiteretausend: 70.74,
              },
              {
                menge: 40000,
                grundpreis: 4381.92,
                weiteretausend: 70.74,
              },
              {
                menge: 50000,
                grundpreis: 5089.28,
                weiteretausend: 70.74,
              },
              {
                menge: 100000,
                grundpreis: 8626.05,
                weiteretausend: 70.74,
              },
              {
                menge: 150000,
                grundpreis: 12162.83,
                weiteretausend: 70.74,
              },
              {
                menge: 200000,
                grundpreis: 15699.61,
                weiteretausend: 70.74,
              },
              {
                menge: 250000,
                grundpreis: 19236.38,
                weiteretausend: 70.74,
              },
              {
                menge: 300000,
                grundpreis: 22773.16,
                weiteretausend: 70.74,
              },
            ],
          },
          {
            seiten: 24,
            gewicht: 49,
            preise: [
              {
                menge: 2500,
                grundpreis: 1839.1,
                weiteretausend: 82.44,
              },
              {
                menge: 5000,
                grundpreis: 2045.21,
                weiteretausend: 82.44,
              },
              {
                menge: 10000,
                grundpreis: 2457.41,
                weiteretausend: 82.44,
              },
              {
                menge: 20000,
                grundpreis: 3281.82,
                weiteretausend: 82.44,
              },
              {
                menge: 30000,
                grundpreis: 4106.23,
                weiteretausend: 82.44,
              },
              {
                menge: 40000,
                grundpreis: 4930.64,
                weiteretausend: 82.44,
              },
              {
                menge: 50000,
                grundpreis: 5755.06,
                weiteretausend: 82.44,
              },
              {
                menge: 100000,
                grundpreis: 9877.11,
                weiteretausend: 82.44,
              },
              {
                menge: 150000,
                grundpreis: 13999.17,
                weiteretausend: 82.44,
              },
              {
                menge: 200000,
                grundpreis: 18121.22,
                weiteretausend: 82.44,
              },
              {
                menge: 250000,
                grundpreis: 22243.28,
                weiteretausend: 82.44,
              },
              {
                menge: 300000,
                grundpreis: 26365.33,
                weiteretausend: 82.44,
              },
            ],
          },
          {
            seiten: 28,
            gewicht: 57,
            preise: [
              {
                menge: 2500,
                grundpreis: 2389.7,
                weiteretausend: 104.88,
              },
              {
                menge: 5000,
                grundpreis: 2651.9,
                weiteretausend: 104.88,
              },
              {
                menge: 10000,
                grundpreis: 3176.3,
                weiteretausend: 104.88,
              },
              {
                menge: 20000,
                grundpreis: 4225.1,
                weiteretausend: 104.88,
              },
              {
                menge: 30000,
                grundpreis: 5273.89,
                weiteretausend: 104.88,
              },
              {
                menge: 40000,
                grundpreis: 6322.69,
                weiteretausend: 104.88,
              },
              {
                menge: 50000,
                grundpreis: 7371.49,
                weiteretausend: 104.88,
              },
              {
                menge: 100000,
                grundpreis: 12615.48,
                weiteretausend: 104.88,
              },
              {
                menge: 150000,
                grundpreis: 17859.47,
                weiteretausend: 104.88,
              },
              {
                menge: 200000,
                grundpreis: 23103.46,
                weiteretausend: 104.88,
              },
              {
                menge: 250000,
                grundpreis: 28347.45,
                weiteretausend: 104.88,
              },
              {
                menge: 300000,
                grundpreis: 33591.44,
                weiteretausend: 104.88,
              },
            ],
          },
          {
            seiten: 32,
            gewicht: 65,
            preise: [
              {
                menge: 2500,
                grundpreis: 2332.74,
                weiteretausend: 114.3,
              },
              {
                menge: 5000,
                grundpreis: 2618.48,
                weiteretausend: 114.3,
              },
              {
                menge: 10000,
                grundpreis: 3189.97,
                weiteretausend: 114.3,
              },
              {
                menge: 20000,
                grundpreis: 4332.94,
                weiteretausend: 114.3,
              },
              {
                menge: 30000,
                grundpreis: 5475.9,
                weiteretausend: 114.3,
              },
              {
                menge: 40000,
                grundpreis: 6618.87,
                weiteretausend: 114.3,
              },
              {
                menge: 50000,
                grundpreis: 7761.84,
                weiteretausend: 114.3,
              },
              {
                menge: 100000,
                grundpreis: 13476.68,
                weiteretausend: 114.3,
              },
              {
                menge: 150000,
                grundpreis: 19191.51,
                weiteretausend: 114.3,
              },
              {
                menge: 200000,
                grundpreis: 24906.35,
                weiteretausend: 114.3,
              },
              {
                menge: 250000,
                grundpreis: 30621.19,
                weiteretausend: 114.3,
              },
              {
                menge: 300000,
                grundpreis: 36336.03,
                weiteretausend: 114.3,
              },
            ],
          },
          {
            seiten: 36,
            gewicht: 73,
            preise: [
              {
                menge: 2500,
                grundpreis: 2779.69,
                weiteretausend: 132.08,
              },
              {
                menge: 5000,
                grundpreis: 3109.88,
                weiteretausend: 132.08,
              },
              {
                menge: 10000,
                grundpreis: 3770.26,
                weiteretausend: 132.08,
              },
              {
                menge: 20000,
                grundpreis: 5091.01,
                weiteretausend: 132.08,
              },
              {
                menge: 30000,
                grundpreis: 6411.77,
                weiteretausend: 132.08,
              },
              {
                menge: 40000,
                grundpreis: 7732.53,
                weiteretausend: 132.08,
              },
              {
                menge: 50000,
                grundpreis: 9053.28,
                weiteretausend: 132.08,
              },
              {
                menge: 100000,
                grundpreis: 15657.07,
                weiteretausend: 132.08,
              },
              {
                menge: 150000,
                grundpreis: 22260.85,
                weiteretausend: 132.08,
              },
              {
                menge: 200000,
                grundpreis: 28864.64,
                weiteretausend: 132.08,
              },
              {
                menge: 250000,
                grundpreis: 35468.42,
                weiteretausend: 132.08,
              },
              {
                menge: 300000,
                grundpreis: 42072.21,
                weiteretausend: 132.08,
              },
            ],
          },
          {
            seiten: 40,
            gewicht: 81,
            preise: [
              {
                menge: 2500,
                grundpreis: 2048.25,
                weiteretausend: 138.5,
              },
              {
                menge: 5000,
                grundpreis: 2394.49,
                weiteretausend: 138.5,
              },
              {
                menge: 10000,
                grundpreis: 3086.98,
                weiteretausend: 138.5,
              },
              {
                menge: 20000,
                grundpreis: 4471.97,
                weiteretausend: 138.5,
              },
              {
                menge: 30000,
                grundpreis: 5856.95,
                weiteretausend: 138.5,
              },
              {
                menge: 40000,
                grundpreis: 7241.93,
                weiteretausend: 138.5,
              },
              {
                menge: 50000,
                grundpreis: 8626.92,
                weiteretausend: 138.5,
              },
              {
                menge: 100000,
                grundpreis: 15551.84,
                weiteretausend: 138.5,
              },
              {
                menge: 150000,
                grundpreis: 22476.75,
                weiteretausend: 138.5,
              },
              {
                menge: 200000,
                grundpreis: 29401.67,
                weiteretausend: 138.5,
              },
              {
                menge: 250000,
                grundpreis: 36326.59,
                weiteretausend: 138.5,
              },
              {
                menge: 300000,
                grundpreis: 43251.51,
                weiteretausend: 138.5,
              },
            ],
          },
          {
            seiten: 44,
            gewicht: 89,
            preise: [
              {
                menge: 2500,
                grundpreis: 1054.31,
                weiteretausend: 172.7,
              },
              {
                menge: 5000,
                grundpreis: 1486.06,
                weiteretausend: 172.7,
              },
              {
                menge: 10000,
                grundpreis: 2349.56,
                weiteretausend: 172.7,
              },
              {
                menge: 20000,
                grundpreis: 4076.55,
                weiteretausend: 172.7,
              },
              {
                menge: 30000,
                grundpreis: 5803.55,
                weiteretausend: 172.7,
              },
              {
                menge: 40000,
                grundpreis: 7530.55,
                weiteretausend: 172.7,
              },
              {
                menge: 50000,
                grundpreis: 9257.55,
                weiteretausend: 172.7,
              },
              {
                menge: 100000,
                grundpreis: 17892.54,
                weiteretausend: 172.7,
              },
              {
                menge: 150000,
                grundpreis: 26527.52,
                weiteretausend: 172.7,
              },
              {
                menge: 200000,
                grundpreis: 35162.51,
                weiteretausend: 172.7,
              },
              {
                menge: 250000,
                grundpreis: 43797.5,
                weiteretausend: 172.7,
              },
              {
                menge: 300000,
                grundpreis: 52432.49,
                weiteretausend: 172.7,
              },
            ],
          },
          {
            seiten: 48,
            gewicht: 97,
            preise: [
              {
                menge: 2500,
                grundpreis: 2077.59,
                weiteretausend: 164.04,
              },
              {
                menge: 5000,
                grundpreis: 2487.68,
                weiteretausend: 164.04,
              },
              {
                menge: 10000,
                grundpreis: 3307.85,
                weiteretausend: 164.04,
              },
              {
                menge: 20000,
                grundpreis: 4948.21,
                weiteretausend: 164.04,
              },
              {
                menge: 30000,
                grundpreis: 6588.56,
                weiteretausend: 164.04,
              },
              {
                menge: 40000,
                grundpreis: 8228.91,
                weiteretausend: 164.04,
              },
              {
                menge: 50000,
                grundpreis: 9869.27,
                weiteretausend: 164.04,
              },
              {
                menge: 100000,
                grundpreis: 18071.04,
                weiteretausend: 164.04,
              },
              {
                menge: 150000,
                grundpreis: 26272.81,
                weiteretausend: 164.04,
              },
              {
                menge: 200000,
                grundpreis: 34474.57,
                weiteretausend: 164.04,
              },
              {
                menge: 250000,
                grundpreis: 42676.34,
                weiteretausend: 164.04,
              },
              {
                menge: 300000,
                grundpreis: 50878.11,
                weiteretausend: 164.04,
              },
            ],
          },
          {
            seiten: 56,
            gewicht: 114,
            preise: [
              {
                menge: 2500,
                grundpreis: 2481.39,
                weiteretausend: 201.36,
              },
              {
                menge: 5000,
                grundpreis: 2984.78,
                weiteretausend: 201.36,
              },
              {
                menge: 10000,
                grundpreis: 3991.56,
                weiteretausend: 201.36,
              },
              {
                menge: 20000,
                grundpreis: 6005.12,
                weiteretausend: 201.36,
              },
              {
                menge: 30000,
                grundpreis: 8018.68,
                weiteretausend: 201.36,
              },
              {
                menge: 40000,
                grundpreis: 10032.24,
                weiteretausend: 201.36,
              },
              {
                menge: 50000,
                grundpreis: 12045.81,
                weiteretausend: 201.36,
              },
              {
                menge: 100000,
                grundpreis: 22113.61,
                weiteretausend: 201.36,
              },
              {
                menge: 150000,
                grundpreis: 32181.42,
                weiteretausend: 201.36,
              },
              {
                menge: 200000,
                grundpreis: 42249.22,
                weiteretausend: 201.36,
              },
              {
                menge: 250000,
                grundpreis: 52317.03,
                weiteretausend: 201.36,
              },
              {
                menge: 300000,
                grundpreis: 62384.83,
                weiteretausend: 201.36,
              },
            ],
          },
          {
            seiten: 64,
            gewicht: 130,
            preise: [
              {
                menge: 2500,
                grundpreis: 2691.53,
                weiteretausend: 227.91,
              },
              {
                menge: 5000,
                grundpreis: 3261.31,
                weiteretausend: 227.91,
              },
              {
                menge: 10000,
                grundpreis: 4400.87,
                weiteretausend: 227.91,
              },
              {
                menge: 20000,
                grundpreis: 6679.99,
                weiteretausend: 227.91,
              },
              {
                menge: 30000,
                grundpreis: 8959.11,
                weiteretausend: 227.91,
              },
              {
                menge: 40000,
                grundpreis: 11238.23,
                weiteretausend: 227.91,
              },
              {
                menge: 50000,
                grundpreis: 13517.35,
                weiteretausend: 227.91,
              },
              {
                menge: 100000,
                grundpreis: 24912.96,
                weiteretausend: 227.91,
              },
              {
                menge: 150000,
                grundpreis: 36308.56,
                weiteretausend: 227.91,
              },
              {
                menge: 200000,
                grundpreis: 47704.16,
                weiteretausend: 227.91,
              },
              {
                menge: 250000,
                grundpreis: 59099.76,
                weiteretausend: 227.91,
              },
              {
                menge: 300000,
                grundpreis: 70495.37,
                weiteretausend: 227.91,
              },
            ],
          },
          {
            seiten: 72,
            gewicht: 146,
            preise: [
              {
                menge: 2500,
                grundpreis: 3379.54,
                weiteretausend: 252.41,
              },
              {
                menge: 5000,
                grundpreis: 4010.57,
                weiteretausend: 252.41,
              },
              {
                menge: 10000,
                grundpreis: 5272.65,
                weiteretausend: 252.41,
              },
              {
                menge: 20000,
                grundpreis: 7796.79,
                weiteretausend: 252.41,
              },
              {
                menge: 30000,
                grundpreis: 10320.94,
                weiteretausend: 252.41,
              },
              {
                menge: 40000,
                grundpreis: 12845.08,
                weiteretausend: 252.41,
              },
              {
                menge: 50000,
                grundpreis: 15369.23,
                weiteretausend: 252.41,
              },
              {
                menge: 100000,
                grundpreis: 27989.96,
                weiteretausend: 252.41,
              },
              {
                menge: 150000,
                grundpreis: 40610.69,
                weiteretausend: 252.41,
              },
              {
                menge: 200000,
                grundpreis: 53231.41,
                weiteretausend: 252.41,
              },
              {
                menge: 250000,
                grundpreis: 65852.14,
                weiteretausend: 252.41,
              },
              {
                menge: 300000,
                grundpreis: 78472.87,
                weiteretausend: 252.41,
              },
            ],
          },
        ],
      },
    },
    Mantel: {
      'Rota 80g': {
        type: 'paged',
        bild: 'produkt-mantel.png',
        kategoriename: 'Mantel',
        verarbeitung: 'mantel',
        druckkosten: 'seiten-gestaffelt',
        minmenge: 2500,

        items: [
          {
            seiten: 4,
            gewicht: 11,
            preise: [
              {
                menge: 2500,
                grundpreis: 1681.60,
                weiteretausend: 51.68,
              },
              {
                menge: 5000,
                grundpreis: 1737.70,
                weiteretausend: 51.68,
              },
              {
                menge: 10000,
                grundpreis: 1996.11,
                weiteretausend: 51.68,
              },
              {
                menge: 20000,
                grundpreis: 2512.94,
                weiteretausend: 51.68,
              },
              {
                menge: 30000,
                grundpreis: 3029.76,
                weiteretausend: 51.68,
              },
              {
                menge: 40000,
                grundpreis: 3546.59,
                weiteretausend: 51.68,
              },
              {
                menge: 50000,
                grundpreis: 4063.42,
                weiteretausend: 51.68,
              },
              {
                menge: 100000,
                grundpreis: 6647.55,
                weiteretausend: 51.68,
              },
              {
                menge: 200000,
                grundpreis: 11815.82,
                weiteretausend: 51.68,
              },
              {
                menge: 250000,
                grundpreis: 14399.95,
                weiteretausend: 51.68,
              },
              {
                menge: 300000,
                grundpreis: 16984.08,
                weiteretausend: 51.68,
              },
            ],
          },
          {
            seiten: 8,
            gewicht: 22,
            preise: [
              {
                menge: 2500,
                grundpreis: 1762.7,
                weiteretausend: 73.02,
              },
              {
                menge: 5000,
                grundpreis: 1868.6,
                weiteretausend: 73.02,
              },
              {
                menge: 10000,
                grundpreis: 2233.69,
                weiteretausend: 73.02,
              },
              {
                menge: 20000,
                grundpreis: 2963.86,
                weiteretausend: 73.02,
              },
              {
                menge: 30000,
                grundpreis: 3694.03,
                weiteretausend: 73.02,
              },
              {
                menge: 40000,
                grundpreis: 4424.21,
                weiteretausend: 73.02,
              },
              {
                menge: 50000,
                grundpreis: 5154.38,
                weiteretausend: 73.02,
              },
              {
                menge: 100000,
                grundpreis: 8805.24,
                weiteretausend: 73.02,
              },
              {
                menge: 150000,
                grundpreis: 12456.11,
                weiteretausend: 73.02,
              },
              {
                menge: 200000,
                grundpreis: 16106.98,
                weiteretausend: 73.02,
              },
              {
                menge: 250000,
                grundpreis: 19757.84,
                weiteretausend: 73.02,
              },
              {
                menge: 300000,
                grundpreis: 23408.71,
                weiteretausend: 73.02,
              },
            ],
          },
          {
            seiten: 12,
            gewicht: 32,
            preise: [
              {
                menge: 2500,
                grundpreis: 1843.79,
                weiteretausend: 94.35,
              },
              {
                menge: 5000,
                grundpreis: 1999.5,
                weiteretausend: 94.35,
              },
              {
                menge: 10000,
                grundpreis: 2471.26,
                weiteretausend: 94.35,
              },
              {
                menge: 20000,
                grundpreis: 3414.78,
                weiteretausend: 94.35,
              },
              {
                menge: 30000,
                grundpreis: 4358.3,
                weiteretausend: 94.35,
              },
              {
                menge: 40000,
                grundpreis: 5301.82,
                weiteretausend: 94.35,
              },
              {
                menge: 50000,
                grundpreis: 6245.34,
                weiteretausend: 94.35,
              },
              {
                menge: 100000,
                grundpreis: 10962.94,
                weiteretausend: 94.35,
              },
              {
                menge: 150000,
                grundpreis: 15680.54,
                weiteretausend: 94.35,
              },
              {
                menge: 200000,
                grundpreis: 20398.14,
                weiteretausend: 94.35,
              },
              {
                menge: 250000,
                grundpreis: 25115.73,
                weiteretausend: 94.35,
              },
              {
                menge: 300000,
                grundpreis: 29833.33,
                weiteretausend: 94.35,
              },
            ],
          },
        ],
      },
      LWC: {
        type: 'single',
        bild: 'produkt-mantel.png',
        kategoriename: 'Mantel',
        verarbeitung: 'mantel',
        druckkosten: 'gestaffelt',
        minmenge: 2500,
        gewicht: 11,
        items: [
          {
            menge: 2500,
            grundpreis: 563.50,
            weiteretausend: 80.02,
          },
          {
            menge: 5000,
            grundpreis: 735,
            weiteretausend: 104.37,
          },
          {
            menge: 10000,
            grundpreis: 1087.50,
            weiteretausend: 93.58,
          },
          {
            menge: 20000,
            grundpreis: 1750,
            weiteretausend: 84.98,
          },
          {
            menge: 30000,
            grundpreis: 2227.50,
            weiteretausend: 81.89,
          },
          {
            menge: 40000,
            grundpreis: 2598.70,
            weiteretausend: 57.85,
          },
          {
            menge: 50000,
            grundpreis: 3062.50,
            weiteretausend: 55.63,
          },
          {
            menge: 100000,
            grundpreis: 5700,
            weiteretausend: 53.40,
          },
          {
            menge: 200000,
            grundpreis: 10798.50,
            weiteretausend: 53.40,
          },
          {
            menge: 300000,
            grundpreis: 15927.50,
            weiteretausend: 53.40,
          },
        ],
      },
    },
    'Tip on Card': {
      Titelseite: {
        bild: 'produkt-tiponcard.png',
        kategoriename: 'Tip on Card',
        type: 'titelseite',
        verarbeitung: 'toc',
        druckkosten: 'gestaffelt',
        minmenge: 2500,
        items: [
          {
            menge: 2500,
            grundpreis: 212.16,
            weiteretausend: 15.27,
          },
          {
            menge: 5000,
            grundpreis: 244.8,
            weiteretausend: 15.27,
          },
          {
            menge: 10000,
            grundpreis: 316.8,
            weiteretausend: 15.27,
          },
          {
            menge: 20000,
            grundpreis: 468.0,
            weiteretausend: 15.27,
          },
          {
            menge: 30000,
            grundpreis: 604.8,
            weiteretausend: 15.27,
          },
          {
            menge: 40000,
            grundpreis: 702.96,
            weiteretausend: 14.76,
          },
          {
            menge: 50000,
            grundpreis: 840.0,
            weiteretausend: 14.11,
          },
          {
            menge: 100000,
            grundpreis: 1360.8,
            weiteretausend: 12.83,
          },
          {
            menge: 200000,
            grundpreis: 2184.0,
            weiteretausend: 12.1,
          },
          {
            menge: 300000,
            grundpreis: 2912.5,
            weiteretausend: 11.64,
          },
          {
            menge: 400000,
            grundpreis: 3480.0,
            weiteretausend: 11.17,
          },
        ],
      },
      U4: {
        bild: 'produkt-postkarte.png',
        kategoriename: 'Postkarte',
        type: 'u4',
        verarbeitung: 'toc',
        druckkosten: 'gestaffelt',
        minmenge: 2500,
        items: [
          {
            menge: 2500,
            grundpreis: 212.16,
            weiteretausend: 15.27,
          },
          {
            menge: 5000,
            grundpreis: 244.8,
            weiteretausend: 15.27,
          },
          {
            menge: 10000,
            grundpreis: 316.8,
            weiteretausend: 15.27,
          },
          {
            menge: 20000,
            grundpreis: 468.0,
            weiteretausend: 15.27,
          },
          {
            menge: 30000,
            grundpreis: 604.8,
            weiteretausend: 15.27,
          },
          {
            menge: 40000,
            grundpreis: 702.96,
            weiteretausend: 14.76,
          },
          {
            menge: 50000,
            grundpreis: 840.0,
            weiteretausend: 14.11,
          },
          {
            menge: 100000,
            grundpreis: 1360.8,
            weiteretausend: 12.83,
          },
          {
            menge: 200000,
            grundpreis: 2184.0,
            weiteretausend: 12.1,
          },
          {
            menge: 300000,
            grundpreis: 2912.5,
            weiteretausend: 11.64,
          },
          {
            menge: 400000,
            grundpreis: 3480.0,
            weiteretausend: 11.17,
          },
        ],
      },
    },
    'Tip on Card - Postkarte': {
      Titelseite: {
        bild: 'produkt-tiponcard.png',
        kategoriename: 'Tip on Card',
        type: 'titelseite',
        verarbeitung: 'toc',
        druckkosten: 'gestaffelt',
        minmenge: 2500,
        items: [
          {
            menge: 2500,
            grundpreis: 415,
            weiteretausend: 39,
          },
          {
            menge: 5000,
            grundpreis: 539.5,
            weiteretausend: 39,
          },
          {
            menge: 10000,
            grundpreis: 734.5,
            weiteretausend: 36.4,
          },
          {
            menge: 20000,
            grundpreis: 1098.5,
            weiteretausend: 35.1,
          },
          {
            menge: 30000,
            grundpreis: 1449.5,
            weiteretausend: 34.45,
          },
          {
            menge: 40000,
            grundpreis: 1794,
            weiteretausend: 33.73,
          },
          {
            menge: 50000,
            grundpreis: 2328,
            weiteretausend: 27.98,
          },
          {
            menge: 100000,
            grundpreis: 3727.2,
            weiteretausend: 26.57,
          },
          {
            menge: 2000000,
            grundpreis: 6384,
            weiteretausend: 24.82,
          },
          {
            menge: 300000,
            grundpreis: 8496.2,
            weiteretausend: 24.58,
          },
          {
            menge: 400000,
            grundpreis: 10953.75,
            weiteretausend: 25.28,
          },
        ],
      },
      U4: {
        bild: 'produkt-postkarte.png',
        kategoriename: 'Postkarte',
        type: 'u4',
        verarbeitung: 'toc',
        druckkosten: 'gestaffelt',
        minmenge: 2500,
        items: [
          {
            menge: 2500,
            grundpreis: 415,
            weiteretausend: 39,
          },
          {
            menge: 5000,
            grundpreis: 539.5,
            weiteretausend: 39,
          },
          {
            menge: 10000,
            grundpreis: 734.5,
            weiteretausend: 36.4,
          },
          {
            menge: 20000,
            grundpreis: 1098.5,
            weiteretausend: 35.1,
          },
          {
            menge: 30000,
            grundpreis: 1449.5,
            weiteretausend: 34.45,
          },
          {
            menge: 40000,
            grundpreis: 1794,
            weiteretausend: 33.73,
          },
          {
            menge: 50000,
            grundpreis: 2328,
            weiteretausend: 27.98,
          },
          {
            menge: 100000,
            grundpreis: 3727.2,
            weiteretausend: 26.57,
          },
          {
            menge: 2000000,
            grundpreis: 6384,
            weiteretausend: 24.82,
          },
          {
            menge: 300000,
            grundpreis: 8496.2,
            weiteretausend: 24.58,
          },
          {
            menge: 400000,
            grundpreis: 10953.75,
            weiteretausend: 25.28,
          },
        ],
      },
    },
    Flyer: {
      none: {
        type: 'single',
        bild: 'produkt-flyer.png',
        kategoriename: 'Flyer',
        verarbeitung: 'beilagen',
        druckkosten: 'gestaffelt',
        minmenge: 2500,
        gewicht: 20,
        items: [
          {
            menge: 2500,
            grundpreis: 372,
            weiteretausend: 45.44,
          },
          {
            menge: 5000,
            grundpreis: 465,
            weiteretausend: 45.44,
          },
          {
            menge: 10000,
            grundpreis: 645,
            weiteretausend: 42.56,
          },
          {
            menge: 20000,
            grundpreis: 949.75,
            weiteretausend: 38.31,
          },
          {
            menge: 30000,
            grundpreis: 1254.25,
            weiteretausend: 36.92,
          },
          {
            menge: 40000,
            grundpreis: 1470,
            weiteretausend: 31.5,
          },
          {
            menge: 50000,
            grundpreis: 1708,
            weiteretausend: 31.5,
          },
          {
            menge: 100000,
            grundpreis: 2782,
            weiteretausend: 29.25,
          },
          {
            menge: 200000,
            grundpreis: 4704,
            weiteretausend: 23.88,
          },
          {
            menge: 300000,
            grundpreis: 6624,
            weiteretausend: 23.88,
          },
        ],
      },
    },
    Folder: {
      none: {
        type: 'single',
        bild: 'produkt-folder.png',
        kategoriename: 'Folder',
        verarbeitung: 'beilagen',
        druckkosten: 'gestaffelt',
        minmenge: 2500,
        gewicht: 20,
        items: [
          {
            menge: 2500,
            grundpreis: 488.4,
            weiteretausend: 84.89,
          },
          {
            menge: 5000,
            grundpreis: 666,
            weiteretausend: 84.89,
          },
          {
            menge: 10000,
            grundpreis: 1005,
            weiteretausend: 76.65,
          },
          {
            menge: 20000,
            grundpreis: 1612.5,
            weiteretausend: 70.71,
          },
          {
            menge: 30000,
            grundpreis: 2130,
            weiteretausend: 70.44,
          },
          {
            menge: 40000,
            grundpreis: 2617.5,
            weiteretausend: 58.35,
          },
          {
            menge: 50000,
            grundpreis: 2954,
            weiteretausend: 54.46,
          },
          {
            menge: 100000,
            grundpreis: 5265,
            weiteretausend: 50.57,
          },
          {
            menge: 200000,
            grundpreis: 9480,
            weiteretausend: 45.48,
          },
          {
            menge: 300000,
            grundpreis: 13800,
            weiteretausend: 45.48,
          },
        ],
      },
    },
  },
  verarbeitung: {
    beilagen: [
      { gewicht: 20, unter40k: 132.9, ueber40k: 129 },
      { gewicht: 40, unter40k: 142.7, ueber40k: 138.5 },
      { gewicht: 60, unter40k: 155.9, ueber40k: 151.3 },
      { gewicht: 80, unter40k: 169.2, ueber40k: 164.2 },
      { gewicht: 100, unter40k: 192.4, ueber40k: 186.7 },
      { gewicht: 120, unter40k: 207.2, ueber40k: 201.0 },
      { gewicht: 140, unter40k: 227.1, ueber40k: 220.3 },
      { gewicht: 160, unter40k: 246.8, ueber40k: 239.4 },
      { gewicht: 180, unter40k: 266.6, ueber40k: 258.7 },
      { gewicht: 200, unter40k: 286.4, ueber40k: 277.9 },
      { gewicht: 220, unter40k: 306.2, ueber40k: 297.1 },
      { gewicht: 240, unter40k: 326, ueber40k: 316.3 },
    ],
    toc: [
      { type: 'titelseite', unter40k: 186, ueber40k: 180.5 },
      { type: 'u4', unter40k: 146.2, ueber40k: 141.9 },
    ],
    mantel: [
      { gewicht: 20, unter40k: 465, ueber40k: 451.1 },
      { gewicht: 40, unter40k: 499.5, ueber40k: 484.6 },
    ],
  },
};

const getters = {};
const mutations = {};
const actions = {};

export default {
  state,
  getters,
  mutations,
  actions,
};
